import * as Yup from 'yup';

const distributorValidation = (t: (key: string) => string) => ({
  updatePassword: Yup.object().shape({
    new_password: Yup.string().required(t('sendPasswordDialog.newPasswordRequired')),
  }),
});

export default distributorValidation;
